export interface IProcessingStatus {
    success?: number;
    warning?: number;
    pending?: number;
    error?: number;
    processing?: number;
}

export enum ProcessingStatus {
    Pending = 'pending',
    Processing = 'processing',
    Success = 'success',
    Warning = 'warning',
    Error = 'error'
}

export interface INameAndSelected {
    name: string;
    selected: boolean;
}
